import { NotificationHelper } from "../../core/util/notificationHelper";
import { AppHelper } from "../../appHelper";
import { AppBaseProps, CommonApp, Context, Entity } from "../../core/components/commonApp";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { Grid } from "../../../app/core/components/grid";
import { Helper } from "../../core/util/helper";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { Button } from "../../core/components/button";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { FieldInstance } from "../../core/components/field";
import { TextBox } from "../../core/components/textBox";
import { ComponentHelper } from "../../core/util/componentHelper";
import { DatePicker } from "../../core/components/datePicker";
import { DialogHelper } from "../../core/util/dialogHelper";
import React from "react"
import ReactDOM from "react-dom";
export default class EditCalendar extends React.Component<EditCalendarProps, any>{
    common = new AppHelper();
    _translations: {};
    _gridOption: {};

    constructor(props) {
        super(props);
        this.common.init(this);
        this._translations = this._getMetaData("translations");
        this.props.context.translations = this._translations;
        this.props.context.hollidaysGridOptions = this._getMetaData("hollidaysGridOptions");
        this._setEvents();
    }

    private _getMetaData = (name: string) => {
        const objects = this.props.metadata.additional.objects;
        for (let i = 0; i < objects.length; i++) {
            if (objects[i].name == name) {
                return objects[i].data;
            }
        }
    }

    private _checkEntity = () =>{
        return true;
    }

    save = (closeAfterSave) => {
        if (this._checkEntity()) {
            if (this.common.validate()) {
                HTTPService.post<JsonResultClass>("Calendar/SaveCalendar", this.props.entity)
                .then(result => {
                    if (result.Code === 0) {
                        this.props.entity.IsNew = false;
                        NotificationHelper.showSuccessMessage(result.Message);
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                    this.common.handlePostSave(result.Code === 0, closeAfterSave);
                    this.setState({});
                });
            }
        } 
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => { //field.model
        if (!isInit) {
            this.common.handleFieldChange(field, value, dataItem);
        }
    }

    private _setEvents = () => {

        $(window).on("CalendarEntityChanged", (e, d) => {
            if (d.update) {
                this.common.setEntityDirtyState(true);
            }
        });
    }


    renderHolidaysGrid = () => {
        return (<HolidayGrid recurringHolidays={this.props.entity.RecurringHolidays} uniqueHolidays={this.props.entity.UniqueHolidays} handleFieldChange={this.handleFieldChange} />)
    }


    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

export interface EditCalendarProps extends AppBaseProps {
    entity: CalendarEntity;
    context: CalendarContext;
}

interface CalendarContext extends Context {
    translations?: {};
    hollidaysGridOptions?: {};
}

export interface CalendarEntity extends Entity {
    Id: number;
    Name: string;
    Color: string;
    IsDeletable: boolean;

    UniqueHolidays: Holiday[];
    RecurringHolidays: Holiday[];
}

//export 

class HolidayGrid extends React.Component<HolidayGridProps, HolidayGridState>{
    private gridOptions: kendo.ui.GridOptions;
    private gridId = kendo.guid();

    constructor(props: HolidayGridProps) {
        super(props)

        this.state = {
            year: new Date().getFullYear()
        }
        this.initApp();

    }

    private initApp = () => {

        const getCheckBox = (id: string) => {
            return `<div style="width: 100%; display: flex; justify-content: center; align-items: center;">
                        <input data-role="${id}" type="checkbox" class="k-checkbox k-checkbox-md k-rounded-md"/>
                    </div>`;
        }

        this.gridOptions = {
            sortable: false,
            pageable: false,
            groupable: false,
            filterable: false,
            selectable: true,
            resizable: true,
            scrollable: true,
            editable: false,
            columns: [
                {
                    field: "Date",
                    title: Helper.getTranslation("Field.BelegMaterial.datum"),
                    template: (holiday: Holiday) => {
                        return holiday.Date;
                    }
                },
                {
                    field: "Name",
                    title: Helper.getTranslation("BrowserTitle.Resource.Available"),
                    template: () => {
                        return `<div style="width: 100%; display: flex; justify-content: center; align-items: center;">
                                    <span class="k-input k-textbox k-input-solid k-input-md k-rounded-md" style="background-color: white">
                                        <input data-role="HolidayName" class="k-input-inner k-valid" maxlength="30"/>
                                    </span>
                                </div>`;
                    }
                },
                {
                    field: "IsRecurring",
                    title: Helper.getTranslation("WebSMS.GeneralSettings.Calender.IsRecurring"),
                    width: 130,
                    template: () => {
                        return getCheckBox("IsRecurringCheckBox");
                    }
                },
                {
                    field: "IsHighHoliday",
                    title: Helper.getTranslation("WebSMS.GeneralSettings.Calender.HighHoliday"),
                    width: 130,
                    template: () => {
                        return getCheckBox("IsHighHolidayCheckBox");
                    }
                },
                {
                    field: "IsHalfDay",
                    title: Helper.getTranslation("WebSMS.GeneralSettings.Calender.HalfWorkingDay"),
                    width: 130,
                    template: () => {
                        return getCheckBox("IsHalfDayCheckBox");
                    }
                }

            ]
        };
    }

    private filterHolidays = (holiday: Holiday) => {
        const date = Util.getDate(holiday.Date);
        return date.getFullYear() == this.state.year;
    }

    private renderGrid = () => {
        let gridData = this.props.uniqueHolidays.filter(this.filterHolidays);
        this.props.recurringHolidays.forEach((holiday) => {
            gridData.push({
                Date: `${holiday.Date}.${this.state.year}`,
                IsRecurring: true,
                IsHalfDay: holiday.IsHalfDay,
                IsHighHoliday: holiday.IsHighHoliday,
                IsNew: false,
                Name: holiday.Name,
                Id: holiday.Id
            })
        });

        const standardButtons: Array<ToolBarStandardButton> = [
            { type: ToolBarStandardButtonType.NEW, caption: Helper.getTranslation("Standard.Neu"), enabled: true },
            { type: ToolBarStandardButtonType.DELETE, caption: Helper.getTranslation("Standard.Loeschen"), enabled: true }
        ];

        return (
            <div className="flex-container" id={this.gridId}>
                <Grid
                    standardButtons={standardButtons}
                    onClickStandardButton={this.onButtonClick}
                    data={gridData.sort(Util.sortHolidays)}
                    options={this.gridOptions}
                    id="holidays"
                    onDataBound={this.onDataBound}
                />
            </div>
        );
    }

    private onButtonClick = async (type: ToolBarStandardButtonType, holiday: Holiday) => {
        switch (type) {
            case ToolBarStandardButtonType.NEW:
                const { name, date} = await Util.generateNew(this.validate);
                this.props.uniqueHolidays.push({
                    IsHalfDay: false,
                    IsHighHoliday: false,
                    IsNew: true,
                    IsRecurring: false,
                    Name: name,
                    Date: date,
                    Id: date
                });
                const year = parseInt(date.split('.')[2]);
                this.setState({ year: year }, () => {
                    this.props.handleFieldChange({ model: "UniqueHolidays" }, this.props.uniqueHolidays);
                });
                break;
            case ToolBarStandardButtonType.DELETE:
                await this.delete(holiday.Date);
                break;
        }
    }


    private delete = async (date: string) => {
        const isOk = await DialogHelper.confirm(Helper.getTranslation("Standard.Msg.Loeschen"));
        if (isOk) {

            const uniqueHolidays = this.props.uniqueHolidays.filter(f => f.Date != date);
            const recurringHolidays = this.props.recurringHolidays.filter(d => {
                const arr_a = date.split('.');
                const arr_b = d.Date.split('.');
                const isSame = arr_a[1] == arr_b[1] && arr_a[0] == arr_b[0];;
                return !isSame;
            });

            this.props.handleFieldChange({ model: "UniqueHolidays" }, uniqueHolidays);
            this.props.handleFieldChange({ model: "RecurringHolidays" }, recurringHolidays);
        }
    }

    private validate = (name: string, date: string) => {
        if (Helper.isNullOrEmpty(name)) {
            NotificationHelper.showWarningMessage(Helper.getTranslation("WebSMS.GeneralSettings.Calender.nameMissing"));
            return false;
        }

        const isInUnique = this.props.uniqueHolidays.findIndex(f => f.Date == date) > -1;
        const isInRecurring = this.props.recurringHolidays.findIndex(d => {
            const arr_a = date.split('.');
            const arr_b = d.Date.split('.');
            return arr_a[1] == arr_b[1] && arr_a[0] == arr_b[0];
        }) > -1;

        if (isInUnique || isInRecurring) {
            NotificationHelper.showWarningMessage("Das angebende Datum ist bereits vergeben");
            return false;
        }

        return true;
    }

    private onDataBound = (event: kendo.ui.GridDataBoundEvent) => {
        console.log("onDataBound")
        const data = event.sender.dataSource.view();
        for (let i = 0; i < data.length; i++) {
            const holiday: Holiday = data[i]
            if (holiday.IsRecurring) {
                const row = event.sender.tbody.find(`tr[data-uid='${data[i].uid}']`);
                const cell = $("td", row);
                cell.css("background-color", "#cfd8dc");
            }


            const cbRecurring = event.sender.tbody.find(`tr[data-uid='${data[i].uid}'] input[data-role="IsRecurringCheckBox"]`) as JQuery<HTMLInputElement>;
            if (holiday.IsRecurring)
                cbRecurring.attr("checked", "true")
            cbRecurring.on("change", (event) => {
                this.toggleRecurring(holiday.Id, event.target.checked);
            });


            const cbHalfDay = event.sender.tbody.find(`tr[data-uid='${data[i].uid}'] input[data-role="IsHalfDayCheckBox"]`) as JQuery<HTMLInputElement>;
            if (holiday.IsHalfDay)
                cbHalfDay.attr("checked", "true")
            cbHalfDay.on("change", (event) => {
                this.updateValue(holiday.Id, event.target.checked, "IsHalfDay");
            });

            const cbHighHoliday = event.sender.tbody.find(`tr[data-uid='${data[i].uid}'] input[data-role="IsHighHolidayCheckBox"]`) as JQuery<HTMLInputElement>;
            if (holiday.IsHighHoliday)
                cbHighHoliday.attr("checked", "true")
            cbHighHoliday.on("change", (event) => {
                this.updateValue(holiday.Id, event.target.checked, "IsHighHoliday");
            });

            const textBox = event.sender.tbody.find(`tr[data-uid='${data[i].uid}'] input[data-role="HolidayName"]`) as JQuery<HTMLInputElement>;
            textBox.val(holiday.Name);
            textBox.on("change", (event) => {
                this.updateValue(holiday.Id, event.target.value, "Name");
            });
        }
    }

    private updateValue = (id: string, value: boolean|string, field: string) => {
        let unique: Holiday[] = JSON.parse(JSON.stringify(this.props.uniqueHolidays));
        let recurring: Holiday[] = JSON.parse(JSON.stringify(this.props.recurringHolidays));


        if (Helper.hasValue(unique.find(f => f.Id == id))) {
            const index = unique.findIndex(f => f.Id == id);
            unique[index][field] = value;
        } else if (Helper.hasValue(recurring.find(f => f.Id == id))) {
            const index = recurring.findIndex(f => f.Id == id);
            recurring[index][field] = value;
        }

        this.props.handleFieldChange({ model: "UniqueHolidays" }, unique);
        this.props.handleFieldChange({ model: "RecurringHolidays" }, recurring);
    }

    private toggleRecurring = (id: string, isRecurring: boolean) => {
        let unique: Holiday[] = JSON.parse(JSON.stringify(this.props.uniqueHolidays));
        let recurring: Holiday[] = JSON.parse(JSON.stringify(this.props.recurringHolidays));

        if (isRecurring) {
            const holiday = unique.find(f => f.Id === id);
            unique = unique.filter(f => f.Id != id);
            const tmp = holiday.Date.split('.');
            const date = `${tmp[0]}.${tmp[1]}`
            recurring.push({
                Date: date,
                Id: date,
                IsHalfDay: holiday.IsHalfDay,
                IsHighHoliday: holiday.IsHighHoliday,
                IsNew: holiday.IsNew,
                IsRecurring: holiday.IsRecurring,
                Name: holiday.Name
            });
        } else {
            const holiday = recurring.find(f => f.Id === id);
            recurring = recurring.filter(f => f.Id != id);
            const date = holiday.Date + "." + this.state.year.toString()
            unique.push({
                Date: date,
                Id: date,
                IsHalfDay: holiday.IsHalfDay,
                IsHighHoliday: holiday.IsHighHoliday,
                IsNew: holiday.IsNew,
                IsRecurring: holiday.IsRecurring,
                Name: holiday.Name
            });
        }
        this.props.handleFieldChange({ model: "UniqueHolidays" }, unique);
        this.props.handleFieldChange({ model: "RecurringHolidays" }, recurring);
    }



    render() {
        return (
            <div style={{ display: "flex", flexDirection: "column" }} >
                <div style={{ display: "flex", margin: "3px", alignItems: "center" }}>
                    <Button handleClick={() => { this.setState({ year: (this.state.year - 1) }) }} iconName={"left"} buttonStyle={{ borderRadius: "var(--rounded-left)" }} />
                    <div style={{ padding: "0 10px", display: "flex", alignItems: "center", borderStyle: "solid", borderWidth: "1px 0", borderColor: "#b3b3b3", height: "38px" }} ><label>{this.state.year}</label></div>
                    <Button handleClick={() => { this.setState({ year: (this.state.year + 1) }) }} iconName={"right"} buttonStyle={{ borderRadius: "var(--rounded-right)" }} />
                </div>
                {this.renderGrid()}
            </div>
        );
    }
}

interface HolidayGridProps {
    uniqueHolidays: Holiday[];
    recurringHolidays: Holiday[];
    handleFieldChange: (field, value) => void;
}

interface HolidayGridState {
    year: number;
}

interface Holiday {
    Id: string;
    Name: string;
    Date: string;
    IsHighHoliday: boolean;
    IsHalfDay: boolean;
    IsNew: boolean;
    IsRecurring: boolean;
}


class Util {

    static getDate = (date: string) => {
        const arr = date.split('.');
        return new Date(parseInt(arr[2]), parseInt(arr[1]) - 1, parseInt(arr[0]));
    }

    static sortHolidays = (a: Holiday, b: Holiday) => {
        const value_a = this.getDate(a.Date).getTime();
        const value_b = this.getDate(b.Date).getTime();


        if (value_a < value_b) {
            return -1;
        }
        if (value_a > value_b) {
            return 1;
        }
        return 0;
    }

    static generateNew = (validate: (name: string, date: string) => boolean) => {
        return new Promise<any>((resolve) => {

            const factory = ComponentHelper.createFactory();


            const targetElement = $("<div>");
            $("body").append(targetElement);

            const remove_dialog = () => {
                ReactDOM.unmountComponentAtNode(targetElement[0]);
                targetElement[0].remove();
            }


            var name = ""
            var date: Date = new Date();

            const dialogProps: DialogProps = {
                title: "",
                actions: [
                    {
                        label: Config.translations.cancel,
                        action: () => {

                        },
                        primary: false
                    },
                    {
                        label: Config.translations.ok,
                        action: () => {
                            const info = {
                                minimumIntegerDigits: 2,
                                useGrouping: false
                            };
                            const d = `${date.getDate().toLocaleString("de", info)}.${(date.getMonth() + 1).toLocaleString("de", info)}.${date.getFullYear()}`;
                            if (!validate(name, d)) {
                                return false;
                            }
                            resolve({
                                name: name,
                                date: d
                            });


                        },
                        primary: true
                    }
                ],
                afterClose: () => {
                    remove_dialog();
                },
                width: 250
            };


            const tBProps = factory.getDefaultTextBoxProps();
            tBProps.value = name;
            tBProps.onChange = (_, value) => {
                name = value;
            }

            const dPProps = factory.getDefaultDatePickerProps();
            dPProps.value = date;
            dPProps.onChange = (_, value) => {
                date = new Date(value)
            }

            ReactDOM.render(
                <Dialog {...dialogProps} open={true}>
                    <FieldInstance label={Helper.getTranslation("BrowserTitle.Resource.Available")} >
                        <TextBox {...tBProps} />
                    </FieldInstance>
                    <FieldInstance label={Helper.getTranslation("Field.BelegMaterial.datum")}>
                        <DatePicker {...dPProps} />
                    </FieldInstance>
                </Dialog >, targetElement[0]);



        })



    }
}